"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsPageView = exports.AnalyticsPageViewContext = exports.AnalyticsPageView = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireWildcard(require("react"));

var _uuid = require("uuid");

var _logging = require("@nerdwallet/logging");

var _useConstant = require("../../hooks/useConstant");

var _ = require("..");

var logger = (0, _logging.getLogger)('AnalyticsPageView');

/**
 * AnalyticsPageViewContext will be used to provide the generated page_view_id or any other stored values to
 * other components if they need it for Segment tracking events.
 */
var AnalyticsPageViewContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.AnalyticsPageViewContext = AnalyticsPageViewContext;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var AnalyticsPageView = function AnalyticsPageView(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      contentId = _ref.contentId,
      contentSource = _ref.contentSource,
      children = _ref.children;

  // eslint-disable-next-line camelcase
  var _useSegmentAnalytics = (0, _.useSegmentAnalytics)(),
      analytics = _useSegmentAnalytics.analytics,
      deployable_name = _useSegmentAnalytics.deployable_name,
      deployable_version = _useSegmentAnalytics.deployable_version,
      deviceId = _useSegmentAnalytics.deviceId;

  var pageViewId = (0, _useConstant.useConstant)(function () {
    return (0, _uuid.v4)();
  });

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isWindowAvailable = _React$useState2[0],
      setIsWindowAvailable = _React$useState2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      pageViewReady = _useState2[0],
      setPageViewReady = _useState2[1];

  (0, _react.useEffect)(function () {
    var timeout = setInterval(function () {
      var _window$nerdwallet, _window$nerdwallet$ui;

      var setHeaderPropsIsAvailable = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) !== undefined && typeof ((_window$nerdwallet = window.nerdwallet) === null || _window$nerdwallet === void 0 ? void 0 : (_window$nerdwallet$ui = _window$nerdwallet.ui) === null || _window$nerdwallet$ui === void 0 ? void 0 : _window$nerdwallet$ui.setHeaderProps) === 'function';

      if (setHeaderPropsIsAvailable) {
        setIsWindowAvailable(true);
        clearInterval(timeout);
      }
    }, 100);
  }, []);
  (0, _react.useEffect)(function () {
    var _window$nerdwallet2, _window$nerdwallet2$u;

    if (!isWindowAvailable) return;
    if (!analytics || !deviceId) return;
    var payload = {
      deployable_name: deployable_name,
      deployable_version: deployable_version,
      pageview_id: pageViewId,
      traditional_device_id: deviceId,
      content_id: contentId,
      content_source: contentSource
    };
    (_window$nerdwallet2 = window.nerdwallet) === null || _window$nerdwallet2 === void 0 ? void 0 : (_window$nerdwallet2$u = _window$nerdwallet2.ui) === null || _window$nerdwallet2$u === void 0 ? void 0 : _window$nerdwallet2$u.setHeaderProps({
      segmentTrackingAttributes: {
        driverPageViewId: pageViewId
      }
    });

    if (name) {
      analytics.page(name, payload);
    } else {
      analytics.page(payload);
    }

    setPageViewReady(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId, isWindowAvailable]);
  return /*#__PURE__*/_react.default.createElement(AnalyticsPageViewContext.Provider, {
    value: {
      pageName: name,
      pageViewId: pageViewId,
      pageViewReady: pageViewReady
    }
  }, children);
};
/**
 *
 * Hook to access all AnalyticsPageViewContext stored values
 * @returns context AnalyticsPageViewContext
 */


exports.AnalyticsPageView = AnalyticsPageView;

var useAnalyticsPageView = function useAnalyticsPageView() {
  var context = (0, _react.useContext)(AnalyticsPageViewContext);

  if (!context) {
    logger.error('useAnalyticsPageView must be used within a <AnalyticsPageView />');
    return null;
  }

  return context;
};

exports.useAnalyticsPageView = useAnalyticsPageView;